/**
 * <s-marquee-expand> — "See all cards" toggle for a card marquee.
 *
 * Clicking the [data-expand-toggle] button sets data-expanded on this element; CSS then stops the
 * marquee and lays every card out in a grid. Clicking again returns to the moving carousel.
 */
class SMarqueeExpand extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-expand-toggle]');
    this.track = this.querySelector('s-drag-marquee');
    this.onClick = () => this.toggle();
    this.button?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  toggle(initial = false) {
    const expanded = !this.hasAttribute('data-expanded');
    this.toggleAttribute('data-expanded', expanded);
    this.button?.setAttribute('aria-expanded', String(expanded));
    if (this.track) this.track.style.transform = '';
    if (!expanded && !initial) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
}

if (!customElements.get('s-marquee-expand')) customElements.define('s-marquee-expand', SMarqueeExpand);
